export default "__VITE_ASSET__Dd_ilFlL__"